import React, { useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import AddressCard from "./AddressCard";
import AddressFormModal from "./AddressFormModal";
import { useAddressStore } from "./store";

function AddressSelectionModal({ show, onHide, userId, customerDetails, onConfirmAddress }) {
  const {
    addresses,
    isLoading,
    selectedAddress,
    setSelectedAddress,
    addAddress,
    updateAddress,
  } = useAddressStore();

  const [showAddressForm, setShowAddressForm] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  // Local selection so user can browse without committing
  const [localSelected, setLocalSelected] = useState(null);

  const handleOpen = () => {
    setLocalSelected(selectedAddress);
  };

  const handleConfirm = () => {
    if (localSelected) {
      setSelectedAddress(localSelected);
      if (onConfirmAddress) {
        onConfirmAddress(localSelected);
      }
    }
    onHide();
  };

  const handleAddNew = () => {
    setEditingAddress(null);
    setShowAddressForm(true);
  };

  const handleEdit = (address) => {
    setEditingAddress(address);
    setShowAddressForm(true);
  };

  const handleAddressSave = async (formData) => {
    if (editingAddress && editingAddress._id) {
      await updateAddress(editingAddress._id, formData, userId);
    } else {
      const addressPayload = {
        first_name: customerDetails?.first_name || "",
        last_name: customerDetails?.last_name || "",
        phone: customerDetails?.phone
          ? `+91${customerDetails.phone.slice(-10)}`
          : "",
        ...formData,
      };
      addAddress(addressPayload);
    }
  };

  const handleSetDefault = (address) => {
    updateAddress(address._id, { is_default: true }, userId);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        onEnter={handleOpen}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16 }}>
            Select Shipping Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {isLoading ? (
            <div className="text-center py-4">
              <Spinner size="sm" /> Loading addresses...
            </div>
          ) : addresses.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-3">No saved addresses found.</p>
              <Button variant="primary" size="sm" onClick={handleAddNew}>
                + Add New Address
              </Button>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3">
                <Button variant="outline-primary" size="sm" onClick={handleAddNew}>
                  + Add New Address
                </Button>
              </div>
              <Row className="g-2">
                {addresses.map((addr) => (
                  <Col xs={12} md={6} key={addr._id}>
                    <AddressCard
                      address={addr}
                      isSelected={localSelected?._id === addr._id}
                      onSelect={setLocalSelected}
                      onEdit={handleEdit}
                      onSetDefault={handleSetDefault}
                    />
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!localSelected}
          >
            Confirm Address
          </Button>
        </Modal.Footer>
      </Modal>

      <AddressFormModal
        show={showAddressForm}
        onHide={() => {
          setShowAddressForm(false);
          setEditingAddress(null);
        }}
        onSave={handleAddressSave}
        editAddress={editingAddress}
      />
    </>
  );
}

export default AddressSelectionModal;
